import React, { ReactNode } from 'react';

import './lesson-banner-view__content.scss';

interface Props {
    children: ReactNode | ReactNode[];
}

export const LessonBannerViewContent = React.memo(({ children }: Props) => {
    return <div className="lesson-banner-view__content">{children}</div>;
});
